import SignalContent from "../signal_content";
import { MstSignallampSettingType } from "../../../types/types";

export function applySetting(self: SignalContent, apiResponse: any) {
  // コンポーネント設定
  self.componentTitle = apiResponse.data.res.mst_signallamp_component_settings.component_title ? apiResponse.data.res.mst_signallamp_component_settings.component_title : "--";
  self.selectDeviceId = apiResponse.data.res.mst_signallamp_component_settings.select_device_id;
  self.useAlertSound = apiResponse.data.res.mst_signallamp_component_settings.use_alert_sound;
}
export function applySignallampSetting(self: SignalContent) {
  // パトランプ(Signallamp Store)設定
  const mstSignallampSetting: any = self.mstSignallampSetting;
  if (self.mstSignallampSettings) {
    self.deviceIds = [];
    // self.deviceIdsの配列を作成
    for (const key in self.mstSignallampSettings) {
      self.deviceIds.push(self.mstSignallampSettings[key].device_id);
    }
    if (!self.selectDeviceId) {
      self.selectDeviceId = mstSignallampSetting.device_id;
    }
    self.authStoreName = mstSignallampSetting.auth_store_name;
    for (const key in self.authStores) {
      if (self.authStoreName === self.authStores[key].store_name) {
        self.authStore = self.authStores[key];
      }
    }
    self.dbTable = mstSignallampSetting.table_name;
    self.location = mstSignallampSetting.location;
    self.lampColorAndFlagMap = mstSignallampSetting.lamp_color_and_flag_map;
  }
  // 扱い易いようにフラグを取り除いて色だけの配列を作り直す
  self.keyColors = [];
  self.lampColors = [];
  for (const lampColorAndFlag in self.lampColorAndFlagMap) {
    self.keyColors.push(self.lampColorAndFlagMap[lampColorAndFlag].color);
  }
  // 設定されたランプの色を反映
  for (let i = 0; i < 4; i++) {
    const color: string =
      typeof self.keyColors[i] !== "undefined" ? self.keyColors[i] : "#cccccc";
    const className: string =
      typeof self.keyColors[i] !== "undefined" ? `lamp-${color}` : "";
    const backColor = `background-color: ${color}`;
    self.lampColors.push({
      className,
      backColor,
      flush: false,
    });
  }
}
export function checkSignallampSettingsThatMatchSelectDeviceId(self: SignalContent) {
  // selectDeviceIdと一致するパトランプ情報を適用させる
  if (self.selectDeviceId) {
    for (const key in self.mstSignallampSettings) {
      if (self.selectDeviceId === self.mstSignallampSettings[key].device_id) {
        self.mstSignallampSetting = self.mstSignallampSettings[key];
      }
    }
  } else {
    self.mstSignallampSetting = self.mstSignallampSettings[0];
  }
}
